import { FC, useState, useEffect } from 'react'

import './style.scss'
import { utils } from '../../utils'
import { Icon, Title } from '../UI'

const indexMin: number = 1
const indexMax: number = 2

const AdminUserFormDocumentsValidate:FC<{ images: any, indexSelected?: number }> = ({ images, indexSelected = 1 })  => {
  const [index, setIndex] = useState<number>(indexMin)

  useEffect(() => {
    setIndex(indexSelected)
  }, [indexSelected])

  const onIndexPrev = () => {
    if(index > indexMin) setIndex(index - 1)
  }

  const onIndexNext = () => {
    if(images && index < indexMax) setIndex(index + 1)
  }

  return (
    <div className="py-60 position-relative">
      <div className="mx-auto" style={{ maxWidth: '620px' }}>
        {index === 1 &&
          <div>
            <Title component="h4" size="22">Fotografía del pasaporte</Title>

            <div className="mt-30 text-center">
              <img src={images.file_passport ? utils.getImagenBase64(images.file_passport): ''} alt="" className="img-max" />
            </div>
          </div>
        }
        {index === 2 &&
          <div className="">
            <Title component="h4" size="22">Fotografía del usuario con su pasaporte</Title>

            <div className="mt-30 text-center">
              <img src={images.file_passport_patient ? utils.getImagenBase64(images.file_passport_patient): ''} alt="" className="img-max" />
            </div>
          </div>
        }
      </div>

      <div className="images-arrows">
        <div onClick={onIndexPrev} className={`images-arrows_prev ${index <= indexMin ? 'images-arrows_prev--disabled' : ''}`}>
          <Icon name="arrow-left" />
        </div>
        <div onClick={onIndexNext} className={`images-arrows_next ${index >= indexMax ? 'images-arrows_next--disabled' : ''}`}>
          <Icon name="arrow-left" />
        </div>
      </div>
    </div>
  )
}

export { AdminUserFormDocumentsValidate }